import { PlusCircleFilled } from "@ant-design/icons";
import { Alert, Card, Col, Collapse, InputNumber, message, Row, Select } from "antd";
import { Form, Input, Button } from "antd";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { GetTokenProducto, TypeIva } from "../../api/utils";
import { productStore, SectionTitle } from "./ProductSimple";
import { baseurl, baseurlwc, credentials } from "../../api/api";
import { useProductStore, ReloadCatalogButton } from "./LayoutProducto";
import { ContableItems } from "./ContableItems";
import { useAttributesStore } from "./Atributes";

const { Option } = Select;

export const ProductoVariante = ({ addProductSimple, variation = false }) => {
  const producto = useProductStore();
  const attributes = useAttributesStore();
  const [form] = Form.useForm();
  const [termselected, settermselected] = useState({});
  const accountingMissing = [0, 1, 2, 4, 5].some(
    (tipo) =>
      !producto.data.ParametrizacionContableProducto?.find(
        (item) => item.Tipo === tipo
      )?.NumeroCuenta
  );
  const [accountingOpen, setAccountingOpen] = useState(accountingMissing);

  // Validar que sea un producto usando useEffect
  useEffect(() => {
    if (!producto.isProduct) {
      message.error("Solo se pueden crear productos, no servicios.");
    }
  }, [producto.isProduct]);

  // Si no es un producto, no renderizamos el formulario
  if (!producto.isProduct) {
    return null;
  }

  const onFinish = (values) => {
    producto.setData({ productstore: productStore });
    if (variation) {
      addVariante(values);
    } else {
      addProductSimple(productStore);
    }

    form.setFieldsValue({ Codigo: "" });
  };

  toast.configure();

  const onFinishFailed = (errorInfo) => {
    // Si falta una cuenta contable, abrir el panel para que el error sea visible
    if (errorInfo.errorFields.some((f) => String(f.name[0]).startsWith("cat"))) {
      setAccountingOpen(true);
    }
    message.info("Por favor complete todos los campos obligatorios");
  };

  const addVariante = (values) => {
    let productS = {
      ...producto.data,
      IdCategoria: producto.data.IdCategoria,
      IdSubCategoria: producto.data.IdSubCategoria,
      Categoria: producto.data.Categoria,
      SubCategoria: producto.data.SubCategoria,
      PrecioVentaConIva1: values.PrecioVentaConIva1,
      PrecioVentaConIva2: values.PrecioVentaConIva2,
      PorcentajeIva: values.PorcentajeIva,
      weight: values.weight,
      TipoProducto: 1, // Fijar explícitamente como producto
      ParametrizacionContableProducto: [
        { NumeroCuenta: values.cat0 || "", Tipo: 0 },
        { NumeroCuenta: values.cat1 || "", Tipo: 1 },
        { NumeroCuenta: values.cat2 || "", Tipo: 2 },
        { NumeroCuenta: values.cat3 || "", Tipo: 4 },
        { NumeroCuenta: values.cat4 || "", Tipo: 5 },
      ],
    };

    productS.Descripcion =
      Cookies.get("productname") + "-" + Object.values(termselected).join("-");

    const getToken = GetTokenProducto(productS);

    toast.promise(getToken, {
      pending: "Obteniendo token...",
      success: "Token obtenido 👌",
      error: "Ocurrió un error ... 🤯",
    });

    getToken.then((token) => {
      let { data } = token;
      if (data) {
        let productotosave = {
          ...productS,
          Token: data,
        };

        toast.info("Guardando producto...", {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        axios
          .post(baseurl + "GuardarProductoConContabilidad", {
            ...productotosave,
          })
          .then((res) => {
            if (res.data.Exito) {
              const filteredAttributes = attributes.selected
                .map((id) => {
                  const name = values[`termselected-${id}`];
                  const group = attributes.list.find((i) => i.id === id);
                  const att = attributes.groups[id]?.find(
                    (i) => i.name === name
                  );
                  return {
                    id: group?.id,
                    option: name,
                    name: group?.name,
                    slug: att?.slug || name.toLowerCase().replace(/\s+/g, "-"),
                  };
                })
                .filter((attr) => attr.id && attr.option && attr.name);

              let producttowc = {
                regular_price: `${productotosave.PrecioVentaConIva1}`,
                price: productotosave.PrecioVentaConIva1,
                manage_stock: true,
                weight: productotosave.weight,
                dimensions: {
                  length: productotosave.dimensions.length,
                  width: productotosave.dimensions.width,
                  height: productotosave.dimensions.height,
                },
                meta_data: [
                  {
                    key: "referencia",
                    value: productotosave.Codigo,
                  },
                ],
                sku: res.data.CodigoBarras,
                attributes: filteredAttributes,
              };

              let idproduct = Cookies.get("productid");
              axios
                .post(
                  `${baseurlwc}/products/${idproduct}/variations?${credentials}`,
                  { ...producttowc }
                )
                .then((res) => {
                  if (res.data.id) {
                    toast.success("Variación guardada con éxito");
                  } else {
                    toast.error(
                      "Ocurrió un error al guardar la variación: " +
                        res.data.message
                    );
                  }
                })
                .catch((error) => {
                  toast.error(
                    "Error al guardar la variación: " +
                      (error.response?.data?.message || error.message)
                  );
                });
            } else {
              toast.error(res.data.MensajeError);
            }
          })
          .catch((error) => {
            toast.error(
              "Error al guardar el producto: " +
                (error.response?.data?.message || error.message)
            );
          });
      }
    });
  };

  const previewName = Object.keys(termselected).length
    ? Cookies.get("productname") + "-" + Object.values(termselected).join("-")
    : "";

  return (
    <Row justify="center" style={{ marginTop: "5px", width: "100%" }}>
      <div style={{ width: "100%" }}>
        <div className="site-card-border-less-wrapper" style={{ width: "100%" }}>
          <Card
            hoverable
            bordered
            title={variation ? "Crear variante" : "Detalles del producto"}
            style={{
              borderRadius: "12px",
              width: "100%",
              margin: "5px 0",
            }}
          >
            <Form
              form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              initialValues={{
                Codigo: producto.data.Codigo,
                IdCategoria: producto.data.IdCategoria,
                IdSubCategoria: producto.data.IdSubCategoria,
                Descripcion: producto.data.Descripcion,
                PrecioVentaConIva1: producto.data.PrecioVentaConIva,
                PrecioVentaConIva2: producto.data.PrecioVentaConIva2,
                PorcentajeIva: producto.data.PorcentajeIva,
                cat0: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 0
                )?.NumeroCuenta,
                cat1: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 1
                )?.NumeroCuenta,
                cat2: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 2
                )?.NumeroCuenta,
                cat3: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 4
                )?.NumeroCuenta,
                cat4: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 5
                )?.NumeroCuenta,
                weight: producto.data.weight,
              }}
            >
              {variation && (
                <Alert
                  type="info"
                  showIcon
                  style={{ marginBottom: 24 }}
                  message={`Nueva variante de: ${Cookies.get("productname") || "producto padre"}`}
                  description={
                    previewName ? (
                      <>
                        Nombre de la variante: <strong>{previewName}</strong>
                      </>
                    ) : (
                      "Elige un término por cada atributo y completa precio, peso y medidas. Al guardar, la variante se crea en ARI y en WooCommerce. Después puedes crear otra cambiando los términos."
                    )
                  }
                />
              )}
              <div style={{ marginBottom: variation ? 0 : "32px" }}>
                {!variation && <SectionTitle>Información Básica</SectionTitle>}
                <Row
                  gutter={[24, 16]}
                  style={{
                    marginLeft: "-12px",
                    marginRight: "-12px",
                    rowGap: "0px",
                  }}
                >
                  {!variation && (
                    <Col xs={24} lg={24}>
                      <Form.Item
                        label="Código de Referencia"
                        name="Codigo"
                        rules={[
                          {
                            required: false,
                            message: "Digita la referencia del producto",
                          },
                        ]}
                        tooltip="Código único para identificar el producto (opcional)"
                      >
                        <Input
                          placeholder="Código de referencia único por variante"
                          maxLength={45}
                          onChange={(value) =>
                            producto.setData({ Codigo: value.target.value })
                          }
                        />
                      </Form.Item>
                    </Col>
                  )}
                  {!variation && (
                    <Col xs={24} lg={24}>
                      <Form.Item
                        label="Nombre del Producto"
                        name="Descripcion"
                        rules={[
                          {
                            required: true,
                            message: "Digite el nombre del producto",
                          },
                        ]}
                        tooltip="Nombre descriptivo del producto"
                      >
                        <Input
                          disabled={variation}
                          placeholder="Ej: Camiseta de Algodón"
                          onChange={(value) =>
                            producto.setData({
                              Descripcion: value.target.value,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                  )}
                  {!variation && (
                    <Col xs={24} lg={12}>
                      <Form.Item
                        name="IdCategoria"
                        label="Categoría"
                        rules={[
                          {
                            required: true,
                            message: "Selecciona una categoría",
                          },
                        ]}
                        tooltip="Selecciona la categoría principal del producto"
                      >
                        <Select
                          onChange={(value) =>
                            producto.setData({
                              IdCategoria: value,
                              Categoria: producto.knowName(
                                value,
                                producto.categorys
                              ),
                            })
                          }
                          placeholder="Selecciona una categoría"
                          allowClear
                          showSearch
                          style={{ width: "100%" }}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          filterSort={(optionA, optionB) =>
                            optionA.children
                              .toLowerCase()
                              .localeCompare(optionB.children.toLowerCase())
                          }
                        >
                          {producto.categorys.map((category) => (
                            <Option key={category.id} value={category.id}>
                              {category.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}
                  {!variation && (
                    <Col xs={24} lg={12}>
                      <Form.Item
                        name="IdSubCategoria"
                        label="Subcategoría"
                        rules={[
                          {
                            required: true,
                            message: "Selecciona una subcategoría",
                          },
                        ]}
                        tooltip="Selecciona una subcategoría"
                      >
                        <Select
                          onChange={(value) =>
                            producto.setData({
                              IdSubCategoria: value,
                              SubCategoria: producto.knowName(
                                value,
                                producto.categorys
                              ),
                            })
                          }
                          placeholder="Selecciona una subcategoría"
                          allowClear
                          showSearch
                          style={{ width: "100%" }}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          filterSort={(optionA, optionB) =>
                            optionA.children
                              .toLowerCase()
                              .localeCompare(optionB.children.toLowerCase())
                          }
                        >
                          {producto.categorys.map((category) => (
                            <Option key={category.id} value={category.id}>
                              {category.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}
                  {!variation && (
                    <Col xs={24} lg={12}>
                    <Form.Item
                      name="IdMarca"
                      label="Marca"
                      tooltip="Selecciona una marca (opcional)"
                    >
                      <Select
                        onChange={(value) => {
                          const selectedBrand = producto.brands.find((b) => b.id === value);
                          producto.setData({
                            IdMarca: value,
                            Marca: selectedBrand?.name,
                            tags: selectedBrand?.name ? [selectedBrand.name] : [],
                          });
                        }}
                        placeholder="Selecciona una marca"
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                      >
                        {producto.brands.map((brand) => (
                          <Option key={brand.id} value={brand.id}>
                            {brand.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    </Col>
                  )}
                  {!variation && (
                    <Col xs={24} lg={12}>
                      <Form.Item label=" " colon={false}>
                        <ReloadCatalogButton />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </div>
              {variation && (
                <div style={{ marginBottom: "24px" }}>
                  <SectionTitle>Términos de la variante</SectionTitle>
                  <Row
                    gutter={[24, 16]}
                    style={{
                      marginLeft: "-12px",
                      marginRight: "-12px",
                      rowGap: "0px",
                    }}
                  >
                    {Object.keys(attributes.data).map((key) => {
                      const attribute = attributes.list.find(
                        (attr) => String(attr.id) === String(key)
                      );
                      const attributeName = attribute ? attribute.name : key;

                      return (
                        <Col xs={24} lg={12} key={key}>
                          <Form.Item
                            name={`termselected-${key}`}
                            label={attributeName}
                            rules={[
                              {
                                required: true,
                                message: "Selecciona un término",
                              },
                            ]}
                            tooltip={`Selecciona un término para ${attributeName}`}
                          >
                            <Select
                              onChange={(value) => {
                                settermselected((old) => ({
                                  ...old,
                                  [key]: value,
                                }));
                              }}
                              placeholder="Selecciona un término"
                              allowClear
                              showSearch
                              style={{ width: "100%" }}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {attributes.data[key].map((termi, index) => (
                                <Option key={index} value={termi}>
                                  {termi}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              )}

              {variation && (
                <div style={{ marginBottom: "24px" }}>
                  <SectionTitle>Detalles Contables</SectionTitle>
                  <Collapse
                    activeKey={accountingOpen ? ["contable"] : []}
                    onChange={(keys) => setAccountingOpen(keys.length > 0)}
                    style={{ background: "#fafafa" }}
                  >
                    <Collapse.Panel
                      key="contable"
                      forceRender
                      header={
                        accountingMissing
                          ? "Faltan cuentas por asignar: revisa la parametrización contable"
                          : "Parametrización contable cargada: clic para revisar o cambiar"
                      }
                    >
                      <ContableItems />
                    </Collapse.Panel>
                  </Collapse>
                </div>
              )}

              {variation && (
                <>
                  <div style={{ marginBottom: "24px" }}>
                    <SectionTitle>Precio e impuestos</SectionTitle>
                    <Row gutter={[24, 0]}>
                      <Col xs={24} md={12}>
                        <Form.Item
                          label="Precio de venta"
                          name="PrecioVentaConIva1"
                          rules={[
                            {
                              required: true,
                              message: "Digite el precio de venta",
                            },
                          ]}
                          tooltip="Precio de venta al público (incluye IVA)"
                        >
                          <InputNumber
                            style={{ width: "100%" }}
                            min={0}
                            precision={0}
                            placeholder="Ej: 200.000"
                            formatter={(value) =>
                              `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                            }
                            parser={(value) => value.replace(/\$\s?|\.+/g, "")}
                            onChange={(value) =>
                              producto.setData({
                                PrecioVentaConIva1: value,
                                PrecioVentaConIva2: value,
                                PrecioVentaConIva3: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                    <Form.Item
                      name="PorcentajeIva"
                      label="Porcentaje IVA"
                      rules={[
                        {
                          required: true,
                          message: "Selecciona un porcentaje IVA",
                        },
                      ]}
                      tooltip="Selecciona el porcentaje de IVA aplicable"
                    >
                      <Select
                        onChange={(value) =>
                          producto.setData({ PorcentajeIva: value })
                        }
                        placeholder="Selecciona el IVA"
                        allowClear
                        style={{ width: "100%" }}
                      >
                        {TypeIva.map((typeiva) => (
                          <Option key={typeiva.Codigo} value={typeiva.Valor}>
                            {typeiva.Descripcion}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                      </Col>
                    </Row>
                  </div>

                  <div style={{ marginBottom: "24px" }}>
                    <SectionTitle>Peso y dimensiones</SectionTitle>
                    <Row gutter={[16, 0]}>
                      <Col xs={12} lg={6}>
                        <Form.Item
                          label="Peso"
                          name="weight"
                          rules={[
                            { required: true, message: "Digite el peso del producto" },
                          ]}
                          tooltip="Peso del producto en kilogramos (ej: 1 o 0.3)"
                        >
                          <InputNumber
                            stringMode
                            min={0}
                            step={0.1}
                            style={{ width: "100%" }}
                            placeholder="Ej: 0.3"
                            addonAfter="kg"
                            onChange={(value) => producto.setData({ weight: value })}
                          />
                        </Form.Item>
                      </Col>
                      {[
                        ["length", "Largo", "Ej: 10"],
                        ["width", "Ancho", "Ej: 5"],
                        ["height", "Alto", "Ej: 2"],
                      ].map(([field, label, placeholder]) => (
                        <Col xs={12} lg={6} key={field}>
                          <Form.Item
                            label={label}
                            name={field}
                            rules={[
                              {
                                required: true,
                                message: `Digita el ${label.toLowerCase()}`,
                              },
                            ]}
                          >
                            <InputNumber
                              stringMode
                              min={0}
                              style={{ width: "100%" }}
                              placeholder={placeholder}
                              addonAfter="cm"
                              onChange={(value) =>
                                producto.setData({
                                  dimensions: {
                                    ...producto.data.dimensions,
                                    [field]: value,
                                  },
                                })
                              }
                            />
                          </Form.Item>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </>
              )}

              {!variation && (
                <div style={{ marginBottom: "24px" }}>
                  <SectionTitle>Impuestos</SectionTitle>
                  <Row gutter={[24, 0]}>
                    <Col xs={24} lg={12}>
                    <Form.Item
                      name="PorcentajeIva"
                      label="Porcentaje IVA"
                      rules={[
                        {
                          required: true,
                          message: "Selecciona un porcentaje IVA",
                        },
                      ]}
                      tooltip="Selecciona el porcentaje de IVA aplicable"
                    >
                      <Select
                        onChange={(value) =>
                          producto.setData({ PorcentajeIva: value })
                        }
                        placeholder="Selecciona el IVA"
                        allowClear
                        style={{ width: "100%" }}
                      >
                        {TypeIva.map((typeiva) => (
                          <Option key={typeiva.Codigo} value={typeiva.Valor}>
                            {typeiva.Descripcion}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    </Col>
                  </Row>
                </div>
              )}

              <div
                style={{
                  position: "sticky",
                  bottom: 0,
                  zIndex: 10,
                  background: "#fff",
                  borderTop: "1px solid #f0f0f0",
                  padding: "12px 0",
                  textAlign: "center",
                }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  shape="round"
                  size="large"
                  icon={<PlusCircleFilled />}
                  style={{ padding: "0 32px", height: "48px", fontWeight: 500 }}
                >
                  {variation ? "Crear variación" : "Crear Producto"}
                </Button>
              </div>
            </Form>
          </Card>
        </div>
      </div>
    </Row>
  );
};